var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._b({staticClass:"cnd-button",class:{
    'cnd-button--size-lg': _vm.size === 'lg',
  },attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},'button',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }